<script>
    import {network, store, uploadFileToCdn} from '../stores.js';
    import TopMenu from '../components/TopMenu.svelte';
    import {Link, navigate} from 'svelte-routing';
    import KontrSelectSearch from "../components/KontrSelectSearch.svelte";
    import ManagerSelectSearch from "../components/ManagerSelectSearch.svelte";
    import FioSelectSearch from "../components/FioSelectSearch.svelte";
    import NewClientModal from '../components/NewClientModal.svelte';
    import NewContactModal from '../components/NewContactModal.svelte';
    import {isNewOrder} from '../lib/orderStatus.js';
    import {
        toArray,
        groupAnalitiki,
        getPeriodList,
        buildFinDvigValues,
        formatAddFinDvigQuery,
        formatEditFinDvigQuery,
        fetchFinOrder,
        orderToForm,
    } from '../lib/orderForm.js';


    export let id = null;
    export let vid = null;

    const isIdMissing = (v) => v == null || v === '' || v === 'undefined' || v === 'null';
    $: isEdit = !isIdMissing(id);

    const user = store('credential', 'getAuth');
    const axis = store('axis', '', false);

    let tipTask = '';
    let problem = '';
    let deadline = '';

    let idKontr = 0;
    let selectedKontakt = null;

    let selectedManagers = [];
    let managerOpen = false;

    let isSubmitting = false;
    let submitSummary = false;
    let formError = '';
    let fieldErrors = {};
    let successBanner = '';
    let successBannerTimeout = null;

    let showNewClientModal = false;
    let showNewContactModal = false;
    let pendingClient = null;

    const loadClients = async () => {
        const result = await network.fetch_proxy(`EXEC getUrlica @svoi = 0`);
        return toArray(result);
    };

    let clientsPromise = loadClients();

    // Стабильный список клиентов — обновляется только при реальном изменении данных
    let clientList = [];
    let clientsLoaded = false;
    $: clientsPromise.then(data => {
        const baseList = toArray(data).map(({idUrllico, name}) => ({idUrllico, name}));
        clientList = pendingClient && !baseList.some(c => +c.idUrllico === +pendingClient.idUrllico)
            ? [...baseList, pendingClient]
            : baseList;
        clientsLoaded = true;
    }).catch(() => {
        clientsLoaded = true;
    });

    // Стабильный список менеджеров — грузим один раз, а не в {#await} шаблона
    let managerList = [];
    let managersLoading = true;
    const loadManagers = async () => {
        try {
            const data = await network.fetch_proxy(`EXEC getSotrud @suvolen = 0`);
            managerList = toArray(data)
                .filter(item => item?.fio)
                .map(({id, fio, tel}) => ({id, fio, name: fio, tel}));
        } finally {
            managersLoading = false;
        }
    };
    loadManagers();

    let projectsList = [];
    let projectsLoading = true;
    const loadProjects = async () => {
        try {
            projectsList = toArray(await network.getProjects());
        } finally {
            projectsLoading = false;
        }
    };
    loadProjects();

    let tipTaskRef;
    let problemRef;
    let deadlineInput;
    let clientRef;
    let managerRef;
    let summa = '';
    let contactRef;
    let vBudjet;
    let vBudjetRef;
    let summaRef;
    let vidOplaty = '';
    let poluchatel = '';
    let fioSamozan = '';

    let vidOplatyRef;
    let poluchatelRef;
    let fioSamozanRef;

    let managerRemountKey = 0;
    let rekvizityFiles = [];
    let rekvizityRef;
    let uploadingFiles = false;
    let uploadedFileNames = [];
    let analitik = '';
    let analitikRef;

    let analitikList = [];
    let analitikLoading = true;
    $: analitikGroups = groupAnalitiki(analitikList);

    let departList = [];
    let departLoading = true;
    let depart = '';
    let departRef;


    let period = '';
    let periodRef;

    $: periodList = getPeriodList(5, period);

    let urlico = '';
    let urlicoRef;
    let urlicoList = [];
    let urlicoLoading = true;

    const MAX_PROBLEM_LENGTH = 500;

    const fieldLabels = {
        tipTask: 'Тип Заявки',
        problem: 'Описание Заявки',
        deadline: 'Срок до',
        client: 'Клиент',
        manager: 'Менеджер',
        contact: 'Контакт',
        summa: 'Сумма',
        vidOplaty: 'Вид оплаты',
        poluchatel: 'Получатель',
        fioSamozan: 'ФИО самозанятого',
        vBudjet : 'В бюджете',
        depart: 'Отдел',
        urlico: 'Юр. лицо'
    };


    let defaultApplied = false;

    $: if (!isEdit && !defaultApplied && managerList.length && $user) {
        const userName = ($user.fio || $user.name || '').trim().toLowerCase();
        const me = managerList.find(m => m.name?.trim().toLowerCase() === userName);

        if (me) {
            selectedManagers = [{ id: me.id, name: me.name }];
            managerRemountKey += 1; // форсируем ремонт с новым selectedIds
        }
        defaultApplied = true;
    }

    let editOrder = null;
    let editExtras = {};
    let editLoadError = '';
    let editLoading = false;
    let formHydrated = false;
    let editFetchStarted = false;

    const loadEditOrder = async () => {
        editLoading = true;
        editLoadError = '';
        try {
            const found = await fetchFinOrder(network, +$user.id, id);
            if (!found) {
                editLoadError = 'not_found';
                return;
            }
            if (!isNewOrder(found)) {
                editLoadError = 'not_editable';
                return;
            }
            editOrder = found;
        } catch (e) {
            editLoadError = 'not_found';
        } finally {
            editLoading = false;
        }
    };

    $: if (isEdit && !editFetchStarted) {
        editFetchStarted = true;
        loadEditOrder();
    }

    $: if (isEdit && editOrder && !formHydrated && !managersLoading && !departLoading && !analitikLoading && !projectsLoading && !urlicoLoading && clientsLoaded) {
        const mapped = orderToForm(editOrder, { managerList, clientList, analitikList, departList, projectsList });
        problem = mapped.problem;
        vBudjet = mapped.vBudjet;
        poluchatel = mapped.poluchatel;
        fioSamozan = mapped.fioSamozan;
        period = mapped.period;
        summa = mapped.summa;
        tipTask = mapped.tipTask;
        analitik = mapped.analitik;
        depart = mapped.depart;
        urlico = mapped.urlico ? String(mapped.urlico) : '';
        if (urlico && !urlicoList.some((item) => String(item.idUrllico) === urlico)) {
            urlicoList = [...urlicoList, { idUrllico: urlico, name: editOrder.urlicoName || `Юр. лицо ${urlico}` }];
        }
        idKontr = mapped.idKontr;
        selectedManagers = mapped.selectedManagers;
        selectedKontakt = mapped.selectedKontakt;
        uploadedFileNames = mapped.uploadedFileNames;
        vidOplaty = mapped.vidOplaty;
        deadline = mapped.deadline;
        rekvizityFiles = [];
        editExtras = mapped.extras;
        managerRemountKey += 1;
        defaultApplied = true;
        formHydrated = true;
    }

    $: backToOrder = `/order/${id}/${vid || editOrder?.vid || 5}`;
    async function onRekvizityFilesSelected(e) {
        const files = Array.from(e.target.files || []);
        if (!files.length) return;

        clearFieldError('rekvizity');
        uploadingFiles = true;

        for (const file of files) {
            try {
                const raw = await uploadFileToCdn(file);
                const item = Array.isArray(raw) ? raw[0] : raw;
                const fromUrl = item?.url_direct && decodeURIComponent(item.url_direct.split('/').pop().split('?')[0]);
                const savedName = fromUrl || item?.name || item?.file || file.name;
                uploadedFileNames = [...uploadedFileNames, savedName];
                rekvizityFiles = [...rekvizityFiles, file];
            } catch (err) {
                fieldErrors = {...fieldErrors, rekvizity: `Не удалось загрузить файл ${file.name}`};
            }
        }

        uploadingFiles = false;
        e.target.value = '';
    }

    function removeRekvizityFile(index) {
        rekvizityFiles = rekvizityFiles.filter((_, i) => i !== index);
        uploadedFileNames = uploadedFileNames.filter((_, i) => i !== index);
    }

    $: rekvizityString = uploadedFileNames.join(',');

    $: filledCount = [tipTask, problem.trim(), deadline, idKontr, selectedManagers.length].filter(Boolean).length;
    $: progress = Math.round((filledCount / 5) * 100);

    $: kontaktsPromise = idKontr
        ? network.fetch_proxy(`EXEC getKontakts @idKontr = ${+idKontr}`)
        : Promise.resolve([]);

    $: managersString = selectedManagers.map(m => m.name).join(', ');

    $: if (poluchatel !== 'Самозанятый') fioSamozan = '';

    const loadAnalitiks = async () => {
        try {
            const result = await network.fetch_proxy(`
            SELECT
                [id],
                [kod],
                [name],
                [operation],
                [actualnost],
                [tip],
                [tipText]
            FROM [analitiki]
            WHERE [actualnost] = 1 AND [operation]=5
        `);
            analitikList = toArray(result);
        } finally {
            analitikLoading = false;
        }
    };
    loadAnalitiks();

    const loadDeparts = async () => {
        try {
            const result = await network.fetch_proxy(`EXEC getDepart`);
            departList = toArray(result);
        } finally {
            departLoading = false;
        }
    };
    loadDeparts();

    const loadUrlica = async () => {
        try {
            const result = await network.fetch_proxy(`EXEC urlicaSvoiActive @svoi = 1, @vid = 0`);
            urlicoList = toArray(result)
                .filter((item) => item?.idUrllico != null && item?.name)
                .map(({ idUrllico, name }) => ({ idUrllico, name }));
        } finally {
            urlicoLoading = false;
        }
    };
    loadUrlica();

    function setDeadline(days) {
        const d = new Date();
        d.setDate(d.getDate() + days);
        deadline = d.toISOString().split('T')[0];
        clearFieldError('deadline');
    }

    function openManager() {
        managerOpen = true;
    }

    function confirmManager() {
        managerOpen = false;
        if (document.activeElement) document.activeElement.blur();
    }

    function toggleManager(item) {
        if (selectedManagers.length > 0 && selectedManagers[0].id === item.id) {
            selectedManagers = [];
        } else {
            selectedManagers = [item];
        }
        managerOpen = false; // закрываем список после выбора
        managerRemountKey += 1;
    }

    function removeManager(id) {
        selectedManagers = selectedManagers.filter(m => m.id !== id);
    }

    function clearFieldError(field) {
        if (fieldErrors[field]) fieldErrors = {...fieldErrors, [field]: ''};
        if (formError) formError = '';
    }

    function onClientCreated(event) {
        const {id, name} = event.detail;
        idKontr = id;
        selectedKontakt = null;
        pendingClient = {idUrllico: id, name};
        showNewClientModal = false;
        clientsPromise = loadClients();
        clearFieldError('client');
        clearFieldError('contact');
    }

    function onContactCreated(event) {
        const {idKontakt, nameKontakt, telefonKontakt} = event.detail;
        selectedKontakt = {idKontakt, nameKontakt, telefonKontakt};
        kontaktsPromise = network.fetch_proxy(`EXEC getKontakts @idKontr = ${+idKontr}`);
        showNewContactModal = false;
        clearFieldError('contact');
    }

    function focusFirstInvalid(errors) {
        const order = [
            ['tipTask', tipTaskRef],
            ['problem', problemRef],
            ['deadline', deadlineInput],
            ['client', clientRef],
            ['manager', managerRef],
            ['contact', contactRef],
            ['summa', summaRef],
            ['vidOplaty', vidOplatyRef],
            ['poluchatel', poluchatelRef],
            ['fioSamozan', fioSamozanRef],
            ['depart', departRef],
            ['urlico', urlicoRef]
        ];
        const first = order.find(([key]) => errors[key]);
        if (first?.[1]) {
            first[1].scrollIntoView({behavior: 'smooth', block: 'center'});
            setTimeout(() => {
                try {
                    first[1].focus?.();
                    first[1].querySelector?.('input, textarea, select, button')?.focus?.();
                } catch (e) {
                }
            }, 180);
        }
    }

    function dismissSuccessBanner() {
        if (successBannerTimeout) {
            clearTimeout(successBannerTimeout);
            successBannerTimeout = null;
        }
        successBanner = '';
        window.scrollTo({ top: 0, behavior: 'smooth' });
        document.getElementById('appCapsule')?.scrollTo?.({ top: 0, behavior: 'smooth' });
    }

    function showCreateSuccess() {
        if (successBannerTimeout) {
            clearTimeout(successBannerTimeout);
            successBannerTimeout = null;
        }
        successBanner = 'Заявка успешно создана';
        successBannerTimeout = setTimeout(dismissSuccessBanner, 3500);

        summa = '0.00';
        problem = '';
        deadline = '';
        rekvizityFiles = [];
        uploadedFileNames = [];
        formError = '';
        period = '';
        depart = '';
        urlico = '';
        tipTask ='';
        analitik ='';
        vBudjet='';
        vidOplaty='';
        poluchatel='';
        idKontr =55;

    }

    function showEditSuccess() {
        if (successBannerTimeout) {
            clearTimeout(successBannerTimeout);
            successBannerTimeout = null;
        }
        successBanner = 'Заявка обновлена';
        successBannerTimeout = setTimeout(() => {
            navigate(backToOrder, { replace: true });
        }, 1800);
    }

    async function validateForm() {
        const errors = {};
        if (!tipTask) errors.tipTask = 'Выберите тип задачи';
        if (!problem || !problem.trim()) errors.problem = 'Заполните описание Заявка';
        if (!deadline) errors.deadline = 'Укажите срок';
        // if (!idKontr) errors.client = 'Выберите клиента';
        if (!selectedManagers.length) errors.manager = 'Выберите ответственного';
        if (summa !== '' && (isNaN(+summa) || +summa < 0)) errors.summa = 'Введите корректную сумму';

        if (!vidOplaty) errors.vidOplaty = 'Выберите вид оплаты';
        if (!poluchatel) errors.poluchatel = 'Выберите получателя';
        if (poluchatel === 'Самозанятый' && (!fioSamozan || !fioSamozan.trim())) {
            errors.fioSamozan = 'Укажите ФИО самозанятого';
        }
        if (!depart) errors.depart = 'Выберите отдел';
        if (!urlico) errors.urlico = 'Выберите юр. лицо';

        fieldErrors = errors;
        if (Object.keys(errors).length) {
            const firstKey = Object.keys(errors)[0];
            formError = `Не заполнено поле: ${fieldLabels[firstKey]}`;
            focusFirstInvalid(errors);
            return false;
        }
        formError = '';
        return true;
    }

    const sendOrder = async () => {
        if (isSubmitting) return;
        const isValid = await validateForm();
        if (!isValid) return;

        submitSummary = true;
        await new Promise(r => setTimeout(r, 800));
        submitSummary = false;

        isSubmitting = true;
        try {
            const fioKey = (fioSamozan ?? '').trim().toLowerCase();
            const sotrFromFio = fioKey
                ? managerList.find(m => (m.fio || m.name || '').trim().toLowerCase() === fioKey)
                : null;
            const sotrId = sotrFromFio?.id ?? 0;

            const extras = isEdit
                ? {
                    ...editExtras,
                    userID: +$user.id,
                    nomDoc: editExtras.nomDoc ?? id,
                    initiat: selectedManagers[0]?.id ?? editExtras.initiat,
                }
                : {
                    userID: +$user.id,
                    nomDoc: 0,
                    operation: 5,
                    initiat: selectedManagers[0]?.id ?? +$user.id,
                };

            const values = buildFinDvigValues({
                period,
                urlico,
                problem,
                vBudjet,
                poluchatel,
                fioSamozan,
                summa,
                idKontr,
                selectedKontakt,
                analitik,
                depart,
                tipTask,
                sotrId,
                selectedManagers,
                rekvizityString,
                vidOplaty,
                deadline,
            }, extras);

            if (isEdit) {
                await network.updateOrder(formatEditFinDvigQuery(values));
                showEditSuccess();
            } else {
                const result = await network.createOrder(formatAddFinDvigQuery(values));
                if ($axis) {
                    window.top.postMessage('add_item::' + JSON.stringify(result), '*');
                }
                showCreateSuccess();
            }
        } catch (e) {
            formError = isEdit
                ? 'Не удалось сохранить заявку. Попробуйте ещё раз.'
                : 'Не удалось создать заявку. Попробуйте ещё раз.';
        } finally {
            isSubmitting = false;
        }
    };

    function formatDate(iso) {
        if (!iso) return '';
        const [y, m, d] = iso.split('-');
        return `${d}.${m}.${y}`;
    }

</script>

<TopMenu title={isEdit ? `Редактирование заявки #${id}` : 'Новая заявка'}>
    <Link to={isEdit ? backToOrder : '/dashboard'} class="headerButton goBack" slot="left">
        <ion-icon name="chevron-back-outline" role="img" class="md hydrated" aria-label="Назад"></ion-icon>
    </Link>
</TopMenu>

<div id="appCapsule">

    {#if isEdit && editLoading}
        <div class="section mt-2">
            <div class="card text-center">
                <div class="card-body p-5">
                    <h5 class="card-title">Загрузка</h5>
                    <p class="card-text">
                        Пожалуйста подождите, мы загружаем данные заявки..
                    </p>
                </div>
            </div>
        </div>
    {:else if isEdit && editLoadError === 'not_found'}
        <div class="section mt-2">
            <div class="card text-center">
                <div class="card-body p-5">
                    <h5 class="card-title">Заявка не найдена</h5>
                    <p class="card-text mb-3">Не удалось загрузить данные заявки #{id}.</p>
                    <Link to="/dashboard" class="btn btn-primary">Назад</Link>
                </div>
            </div>
        </div>
    {:else if isEdit && editLoadError === 'not_editable'}
        <div class="section mt-2">
            <div class="card text-center">
                <div class="card-body p-5">
                    <h5 class="card-title">Редактирование недоступно</h5>
                    <p class="card-text mb-3">Заявку можно редактировать только в статусе «Новые».</p>
                    <Link to={backToOrder} class="btn btn-primary">К заявке</Link>
                </div>
            </div>
        </div>
    {:else}

    <div class="mt-2 mb-5  sticky-top" >
        <div class="progress-wrap">
            <div class="progress-bar-fill" style="width: {progress}%"></div>
        </div>
        {#if progress < 100}
            <div class="progress-label">Заполнено {progress}%</div>
        {:else}
            <div class="progress-label progress-label--done">Всё заполнено ✓</div>
        {/if}



    </div>

    <div class="section mt-2 mb-5 create-page">

        {#if formError}
            <div class="form-alert" role="alert">
                <ion-icon name="alert-circle-outline"></ion-icon>
                <span>{formError}</span>
            </div>
        {/if}



        <div class="form-group boxed" bind:this={departRef}>
            <div class="input-wrapper">
                <label class="form-label" for="depart">Отдел</label>
                <select
                        class="form-control form-select {fieldErrors.depart ? 'is-invalid' : ''}"
                        id="depart"
                        bind:value={depart}
                        on:change={() => clearFieldError('depart')}
                        disabled={departLoading}
                >
                    {#if departLoading}
                        <option disabled>Загрузка..</option>
                    {:else}
                        <option value="" disabled>Выберите</option>
                        {#each departList as item}
                            <option value="{item.kod}">{item.name}</option>
                        {/each}
                    {/if}
                </select>
                {#if fieldErrors.depart}
                    <div class="field-error">{fieldErrors.depart}</div>
                {/if}
            </div>
        </div>

        <!-- 5. Менеджер -->
        <div class="form-group boxed" bind:this={managerRef}>
            <div class="input-wrapper">
                {#if managersLoading}
                    <p>Загрузка...</p>
                {:else}
                    <label class="form-label">Ответственный</label>
                    <div class="manager-select-wrap {fieldErrors.manager ? 'invalid-shell' : ''}">
                        {#key managerRemountKey}
                            <ManagerSelectSearch
                                    items={managerList}
                                    selectedIds={selectedManagers.map(m => m.id)}
                                    on:select={({ detail }) => toggleManager(detail)}
                                    on:focus={openManager}
                            />
                        {/key}
                        {#if managerOpen}
                            <button type="button" class="manager-ok-btn" on:click={confirmManager}
                                    aria-label="Подтвердить выбор">
                                <ion-icon name="checkmark-outline"></ion-icon>
                            </button>
                        {/if}
                    </div>
                    {#if fieldErrors.manager }
                        <div class="field-error">{fieldErrors.manager}</div>
                    {/if}

                    {#if selectedManagers.length > 0}
                        <div class="manager-chips">
                            {#each selectedManagers as mgr}
                            <span class="manager-chip">
                                {mgr.name}
                                <button type="button" class="chip-remove"
                                        on:click={() => removeManager(mgr.id)}>✕</button>
                            </span>
                            {/each}
                        </div>
                    {/if}
                {/if}
            </div>
        </div>


        <!-- Сумма -->
        <div class="form-group boxed" bind:this={summaRef}>
            <div class="input-wrapper">
                <label class="form-label" for="summa">Сумма</label>
                <div class="date-input-wrap {fieldErrors.summa ? 'invalid-wrap' : ''}">
                    <ion-icon name="cash-outline" class="date-icon-left"></ion-icon>
                    <input
                            type="number"
                            id="summa"
                            min="0"
                            step="0.01"
                            inputmode="decimal"
                            class="form-control date-control {fieldErrors.summa ? 'is-invalid' : ''}"
                            placeholder="0.00"
                            bind:value={summa}
                            on:input={() => clearFieldError('summa')}
                            on:focus={(e) => e.target.select()}
                            on:click={(e) => e.target.select()}
                    >
                </div>
                {#if fieldErrors.summa}
                    <div class="field-error">{fieldErrors.summa}</div>
                {/if}
            </div>
        </div>


        <!-- 3. Описание -->
        <div class="form-group boxed" bind:this={problemRef}>
            <div class="input-wrapper">
                <label class="form-label" for="note">Краткое описание </label>
                <textarea
                        id="note"
                        rows="3"
                        maxlength={MAX_PROBLEM_LENGTH}
                        class="form-control {fieldErrors.problem ? 'is-invalid' : ''}"
                        placeholder="Краткое описание запроса на оплату (с указанием ФИО получателя)"
                        bind:value={problem}
                        on:input={() => clearFieldError('problem')}
                ></textarea>
                <div class="textarea-footer">
                    {#if fieldErrors.problem}
                        <div class="field-error">{fieldErrors.problem}</div>
                    {:else}
                        <span></span>
                    {/if}
                    <span class="char-counter {problem.length > MAX_PROBLEM_LENGTH * 0.9 ? 'char-counter--warn' : ''}">
                        {problem.length}/{MAX_PROBLEM_LENGTH}
                    </span>
                </div>
            </div>
        </div>


        <!-- Вид оплаты -->
        <div class="form-group boxed" bind:this={vidOplatyRef}>
            <div class="input-wrapper">
                <label class="form-label">Вид оплаты</label>
                <div class="radio-pill-group {fieldErrors.vidOplaty ? 'invalid-shell' : ''}">
                    <label class="radio-pill">
                        <input type="radio" name="vidOplaty" value="Наличные" bind:group={vidOplaty}
                               on:change={() => clearFieldError('vidOplaty')}>
                        <span>Наличные</span>
                    </label>
                    <label class="radio-pill">
                        <input type="radio" name="vidOplaty" value="Безналичные" bind:group={vidOplaty}
                               on:change={() => clearFieldError('vidOplaty')}>
                        <span>Безналичные</span>
                    </label>
                </div>
                {#if fieldErrors.vidOplaty}
                    <div class="field-error">{fieldErrors.vidOplaty}</div>
                {/if}
            </div>
        </div>

        <!-- Получатель -->
        <div class="form-group boxed" bind:this={poluchatelRef}>
            <div class="input-wrapper">
                <label class="form-label">Получатель</label>
                <div class="radio-pill-group {fieldErrors.poluchatel ? 'invalid-shell' : ''}">
                    <label class="radio-pill">
                        <input type="radio" name="poluchatel" value="Юр.лицо" bind:group={poluchatel}
                               on:change={() => clearFieldError('poluchatel')}>
                        <span>Юр.лицо/ИП</span>
                    </label>

                    <label class="radio-pill">
                        <input type="radio" name="poluchatel" value="Самозанятый" bind:group={poluchatel}
                               on:change={() => clearFieldError('poluchatel')}>
                        <span>Самозанятый/Физ.лицо</span>
                    </label>
                </div>
                {#if fieldErrors.poluchatel}
                    <div class="field-error">{fieldErrors.poluchatel}</div>
                {/if}

                {#if poluchatel === 'Самозанятый'}
                    <div class="fade-in" bind:this={fioSamozanRef} style="margin-top: 12px;">
                        <label class="form-label" for="fioSamozan">ФИО самозанятого</label>
                        {#if managersLoading}
                            <p>Загрузка...</p>
                        {:else}
                            <FioSelectSearch
                                    id="fioSamozan"
                                    items={managerList}
                                    bind:value={fioSamozan}
                                    invalid={!!fieldErrors.fioSamozan}
                                    placeholder="Выберите из справочника или введите ФИО"
                                    on:input={() => clearFieldError('fioSamozan')}
                            />
                        {/if}
                        {#if fieldErrors.fioSamozan}
                            <div class="field-error">{fieldErrors.fioSamozan}</div>
                        {/if}
                    </div>
                {/if}

                {#if poluchatel === 'Юр.лицо'}

                    <div class="form-group boxed" bind:this={clientRef}>
                    <div class="input-wrapper">
                        <label class="form-label">Контрагент</label>
                        <div class:invalid-shell={fieldErrors.client}>
                            <KontrSelectSearch
                                    items={clientList}
                                    defaults=55
                                    selectedId={idKontr}
                                    on:select={({ detail }) => {
                            idKontr = detail.id ?? $user.idkontr;
                            selectedKontakt = null;
                            clearFieldError('client');

                        }}
                            />
                            <button
                                    type="button"
                                    class="btn btn-outline-secondary btn-sm mt-1"
                                    on:click={() => showNewClientModal = true}
                            >
                                + Новый контрагент
                            </button>

                        </div>
                        {#if fieldErrors.client}
                            <div class="field-error">{fieldErrors.client}</div>
                        {/if}
                    </div>
                </div>

                {/if}


            </div>
        </div>


        <!-- Реквизиты для оплаты -->
        <div class="form-group boxed" bind:this={rekvizityRef}>
            <div class="input-wrapper">
                <label class="form-label">Реквизиты для оплаты</label>

                <label class="file-drop {fieldErrors.rekvizity ? 'invalid-shell' : ''}">
                    <input
                            type="file"
                            multiple
                            accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                            on:change={onRekvizityFilesSelected}
                            style="display:none"
                            disabled={uploadingFiles}
                    >
                    <ion-icon name="attach-outline"></ion-icon>
                    <span>{uploadingFiles ? 'Загрузка...' : 'Прикрепить файл(ы)'}</span>
                    {#if uploadingFiles}<span class="btn-spinner file-spinner"></span>{/if}
                </label>

                {#if uploadedFileNames.length > 0}
                    <div class="file-list fade-in">
                        {#each uploadedFileNames as fileName, i (fileName + '-' + i)}
                            <div class="file-attached">
                                <ion-icon name="document-attach-outline"></ion-icon>
                                <span class="file-name">{fileName}</span>
                                <button type="button" class="chip-remove" on:click={() => removeRekvizityFile(i)}>✕
                                </button>
                            </div>
                        {/each}
                    </div>
                {/if}

                {#if fieldErrors.rekvizity}
                    <div class="field-error">{fieldErrors.rekvizity}</div>
                {/if}
            </div>
        </div>

        <!-- 2. Тип задачи -->
        <div class="form-group boxed" bind:this={tipTaskRef}>
            <div class="input-wrapper">
                <label class="form-label" for="tipTask">Продукт/Услуга </label>
                <select
                        class="form-control form-select {fieldErrors.tipTask ? 'is-invalid' : ''}"
                        id="tipTask"
                        bind:value={tipTask}
                        on:change={() => clearFieldError('tipTask')}
                        disabled={projectsLoading}
                >
                    {#if projectsLoading}
                        <option disabled>Загрузка..</option>
                    {:else}
                        <option value="" disabled>Выберите</option>
                        {#each projectsList as item}
                            <option value="{item.kod ?? item.id}">{item.name}</option>
                        {/each}
                    {/if}
                </select>
                {#if fieldErrors.tipTask}
                    <div class="field-error">{fieldErrors.tipTask}</div>
                {/if}
            </div>
        </div>


        <div class="form-group boxed" bind:this={analitikRef}>
            <div class="input-wrapper">
                <label class="form-label" for="analitik">Статья расходов</label>
                <select
                        class="form-control form-select {fieldErrors.analitik ? 'is-invalid' : ''}"
                        id="analitik"
                        bind:value={analitik}
                        on:change={() => clearFieldError('analitik')}
                        disabled={analitikLoading}
                >
                    {#if analitikLoading}
                        <option disabled>Загрузка..</option>
                    {:else}
                        <option value="" disabled>Выберите</option>
                        {#each analitikGroups as group, groupIndex (`${group.tip}-${groupIndex}`)}
                            <optgroup label={group.label}>
                                {#each group.items as item, itemIndex (`${item.kod}-${item.id}-${itemIndex}`)}
                                    <option value="{item.kod}">{item.kod} - {item.name}</option>
                                {/each}
                            </optgroup>
                        {/each}
                    {/if}
                </select>
                {#if fieldErrors.analitik}
                    <div class="field-error">{fieldErrors.analitik}</div>
                {/if}
            </div>
        </div>



        <!-- Вид оплаты -->
        <div class="form-group boxed" bind:this={vBudjetRef}>
            <div class="input-wrapper">
                <label class="form-label">В бюджете</label>
                <div class="radio-pill-group {fieldErrors.vBudjet ? 'invalid-shell' : ''}">
                    <label class="radio-pill">
                        <input type="radio" name="vBudjet" value="Да" bind:group={vBudjet}
                               on:change={() => clearFieldError('vBudjet')}>
                        <span>Да</span>
                    </label>
                    <label class="radio-pill">
                        <input type="radio" name="vBudjet" value="Нет" bind:group={vBudjet}
                               on:change={() => clearFieldError('vBudjet')}>
                        <span>Нет</span>
                    </label>
                </div>
                {#if fieldErrors.vBudjet}
                    <div class="field-error">{fieldErrors.vBudjet}</div>
                {/if}
            </div>
        </div>


        <!-- 2. Период списания -->
        <div class="form-group boxed" bind:this={periodRef}>
            <div class="input-wrapper">
                <label class="form-label" for="period">Период списания</label>
                <select
                        class="form-control form-select {fieldErrors.period ? 'is-invalid' : ''}"
                        id="period"
                        bind:value={period}
                        on:change={() => clearFieldError('period')}
                >
                    <option value="" disabled>Выберите</option>
                    {#each periodList as item}
                        <option value="{item.kod}">{item.name}</option>
                    {/each}
                </select>
                {#if fieldErrors.period}
                    <div class="field-error">{fieldErrors.period}</div>
                {/if}
            </div>
        </div>

        <div class="form-group boxed" bind:this={urlicoRef}>
            <div class="input-wrapper">
                <label class="form-label" for="urlico">Юр. лицо</label>
                <select
                        class="form-control form-select {fieldErrors.urlico ? 'is-invalid' : ''}"
                        id="urlico"
                        bind:value={urlico}
                        on:change={() => clearFieldError('urlico')}
                        disabled={urlicoLoading}
                >
                    {#if urlicoLoading}
                        <option disabled>Загрузка..</option>
                    {:else}
                        <option value="" disabled>Выберите</option>
                        {#each urlicoList as item (item.idUrllico)}
                            <option value="{item.idUrllico}">{item.name}</option>
                        {/each}
                    {/if}
                </select>
                {#if fieldErrors.urlico}
                    <div class="field-error">{fieldErrors.urlico}</div>
                {/if}
            </div>
        </div>



        <!-- 4. Срок до -->
        <div class="form-group boxed">
            <div class="input-wrapper">
                <label class="form-label" for="deadline">Оплатить</label>

                <div class="date-input-wrap {fieldErrors.deadline ? 'invalid-wrap' : ''}">
                    <ion-icon name="calendar-outline" class="date-icon-left"></ion-icon>
                    <input
                            type="date"
                            id="deadline"
                            class="form-control date-control {fieldErrors.deadline ? 'is-invalid' : ''}"
                            bind:value={deadline}
                            bind:this={deadlineInput}
                            on:input={() => clearFieldError('deadline')}
                    >
                </div>

                <div class="date-shortcuts">
                    <button type="button" class="shortcut-btn" on:click={() => setDeadline(1)}>Завтра</button>
                    <button type="button" class="shortcut-btn" on:click={() => setDeadline(3)}>+3 дня</button>
                    <button type="button" class="shortcut-btn" on:click={() => setDeadline(7)}>+7 дней</button>
                    <button type="button" class="shortcut-btn" on:click={() => setDeadline(14)}>+2 недели</button>
                </div>

                {#if fieldErrors.deadline}
                    <div class="field-error">{fieldErrors.deadline}</div>
                {/if}
            </div>
        </div>


        <div class="form-button-group sticky-submit">
            <button
                    on:click={sendOrder}
                    class="btn btn-primary btn-block btn-lg submit-btn"
                    disabled={isSubmitting || submitSummary}
            >
                {#if submitSummary}
                    <ion-icon name="checkmark-circle-outline"></ion-icon>
                    {tipTask} · {managersString} · {formatDate(deadline)}
                {:else if isSubmitting}
                    <span class="btn-spinner"></span>
                    {isEdit ? 'Сохранение...' : 'Создание...'}
                {:else}
                    {isEdit ? 'Сохранить' : 'Создать заявку'}
                {/if}
            </button>
        </div>

    </div>
    {/if}
</div>

{#if successBanner}
    <div class="success-overlay" role="status" aria-live="polite">
        <button type="button" class="success-overlay-dismiss" aria-label="Закрыть" on:click={dismissSuccessBanner}>✕</button>
        <div class="success-overlay-content">
            <div class="success-check" aria-hidden="true">
                <svg class="success-check-svg" viewBox="0 0 52 52">
                    <circle class="success-check-circle" cx="26" cy="26" r="24" fill="none"/>
                    <path class="success-check-mark" fill="none" d="M14.5 27.5l7.5 7.5 15.5-16"/>
                </svg>
            </div>
            <p class="success-overlay-title">{successBanner}</p>
        </div>
    </div>
{/if}

{#if showNewClientModal}
    <NewClientModal
            on:created={onClientCreated}
            on:close={() => showNewClientModal = false}
    />
{/if}

{#if showNewContactModal}
    <NewContactModal
            idKontr={idKontr}
            on:created={onContactCreated}
            on:close={() => showNewContactModal = false}
    />
{/if}

<style>
    .create-page {
        padding-bottom: 88px;
    }

    .progress-wrap {
        height: 4px;
        background: #e9ecef;
        border-radius: 999px;
        overflow: hidden;
        margin-bottom: 4px;
    }

    .progress-bar-fill {
        height: 100%;
        background: linear-gradient(90deg, #0b7285, #22c55e);
        border-radius: 999px;
        transition: width 0.4s ease;
    }

    .progress-label {
        font-size: 11px;
        color: #9ca3af;
        text-align: right;
        margin-bottom: 12px;
    }

    .progress-label--done {
        color: #16a34a;
        font-weight: 600;
    }

    .form-alert {
        display: flex;
        align-items: center;
        gap: 10px;
        background: #fff4f4;
        color: #b42318;
        border: 1px solid #f0c7c7;
        border-radius: 12px;
        padding: 12px 14px;
        margin-bottom: 14px;
        font-size: 14px;
        animation: fadeIn 0.2s ease;
    }

    .form-alert ion-icon {
        font-size: 20px;
        flex-shrink: 0;
    }

    .success-overlay {
        position: fixed;
        inset: 0;
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(165deg, #ecfdf3 0%, #f0f7f8 45%, #ffffff 100%);
        animation: successOverlayIn 0.28s ease;
    }

    .success-overlay-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        padding: 24px;
        text-align: center;
    }

    .success-overlay-title {
        margin: 0;
        font-size: 20px;
        font-weight: 700;
        color: #067647;
        letter-spacing: 0.01em;
        animation: successTitleIn 0.35s ease 0.45s both;
    }

    .success-overlay-dismiss {
        position: absolute;
        top: calc(12px + env(safe-area-inset-top));
        right: 16px;
        background: none;
        border: none;
        color: #067647;
        cursor: pointer;
        font-size: 20px;
        line-height: 1;
        padding: 8px 10px;
        border-radius: 8px;
        opacity: 0.75;
    }

    .success-overlay-dismiss:hover {
        opacity: 1;
        background: rgba(22, 163, 74, 0.12);
    }

    .success-check {
        width: 88px;
        height: 88px;
    }

    .success-check-svg {
        width: 100%;
        height: 100%;
        display: block;
    }

    .success-check-circle {
        stroke: #16a34a;
        stroke-width: 2.5;
        stroke-dasharray: 166;
        stroke-dashoffset: 166;
        stroke-linecap: round;
        animation: successCircle 0.55s ease-in-out forwards;
    }

    .success-check-mark {
        stroke: #16a34a;
        stroke-width: 3.2;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-dasharray: 48;
        stroke-dashoffset: 48;
        animation: successMark 0.35s ease-out 0.4s forwards;
    }

    @keyframes successOverlayIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    @keyframes successTitleIn {
        from {
            opacity: 0;
            transform: translateY(8px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @keyframes successCircle {
        to {
            stroke-dashoffset: 0;
        }
    }

    @keyframes successMark {
        to {
            stroke-dashoffset: 0;
        }
    }

    .form-label {
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0.02em;
        color: #6b7280;
        margin-bottom: 8px;
        display: block;
    }

    .form-control, .form-select {
        border-radius: 12px;
        border: 1px solid #d8dde3;
        background: #fff;
        min-height: 50px;
        box-shadow: none;
        transition: border-color .18s ease, box-shadow .18s ease;
    }

    textarea.form-control {
        min-height: 96px;
        padding-top: 12px;
        resize: vertical;
    }

    .form-control:focus, .form-select:focus {
        border-color: #0b7285;
        box-shadow: 0 0 0 4px rgba(11, 114, 133, 0.08);
    }

    .form-select optgroup {
        font-style: normal;
        font-weight: 600;
        color: #374151;
    }

    .form-select optgroup option {
        font-weight: 400;
        color: #111827;
    }

    .is-invalid {
        border-color: #e5484d !important;
        background: #fffafa;
    }

    .invalid-shell :global(input), .invalid-shell :global(.form-control) {
        border-color: #e5484d !important;
    }

    .field-error {
        margin-top: 7px;
        font-size: 12px;
        color: #c62828;
    }

    .textarea-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 6px;
    }

    .char-counter {
        font-size: 11px;
        color: #9ca3af;
        margin-left: auto;
    }

    .char-counter--warn {
        color: #f97316;
        font-weight: 600;
    }

    .date-input-wrap {
        position: relative;
        display: flex;
        align-items: center;
    }

    .date-icon-left {
        position: absolute;
        left: 14px;
        font-size: 18px;
        color: #0b7285;
        pointer-events: none;
        z-index: 2;
    }

    .date-control {
        padding-left: 42px !important;
        cursor: pointer;
    }

    .date-control::-webkit-calendar-picker-indicator {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        cursor: pointer;
    }

    .date-shortcuts {
        display: flex;
        gap: 6px;
        margin-top: 8px;
        flex-wrap: wrap;
    }

    .shortcut-btn {
        padding: 5px 12px;
        border-radius: 999px;
        border: 1px solid #d1d5db;
        background: #fff;
        font-size: 12px;
        font-weight: 500;
        color: #374151;
        cursor: pointer;
        transition: all 0.15s ease;
    }

    .shortcut-btn:hover {
        background: #e8f4f5;
        border-color: #0b7285;
        color: #0b7285;
    }

    .shortcut-btn:active {
        transform: scale(0.96);
    }

    .kontakt-card {
        background: #f7f8f8;
        border: 1px solid #e3e7ea;
        border-radius: 12px;
        padding: 12px 14px;
        margin: 0 0 12px 0;
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .kontakt-row {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;
    }

    .kontakt-label {
        color: #7a7974;
        min-width: 64px;
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: 0.06em;
    }

    .kontakt-value {
        color: #28251d;
        font-weight: 500;
    }

    .kontakt-tel {
        color: #01696f;
        text-decoration: none;
    }

    .kontakt-tel:hover {
        text-decoration: underline;
    }

    .kontakt-empty {
        font-size: 13px;
        color: #7a7974;
        padding: 4px 0;
        margin: 0;
    }

    .kontakt-error {
        color: #a12c7b;
    }

    .manager-select-wrap {
        position: relative;
    }

    .manager-select-wrap :global(input) {
        padding-right: 48px !important;
    }

    .manager-ok-btn {
        position: absolute;
        top: 9px;
        right: 10px;
        z-index: 1000;
        width: 32px;
        height: 32px;
        border: none;
        border-radius: 50%;
        background: #16a34a;
        color: #fff;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 8px 18px rgba(22, 163, 74, 0.22);
        cursor: pointer;
        transition: transform .12s ease, background .18s ease;
    }

    .manager-ok-btn:active {
        transform: scale(0.95);
        background: #15803d;
    }

    .manager-ok-btn ion-icon {
        font-size: 18px;
        pointer-events: none;
    }

    .manager-chips {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
        margin-top: 10px;
    }

    .manager-chip {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        background-color: #e8f4f5;
        color: #01696f;
        border: 1px solid #b2d8db;
        border-radius: 999px;
        padding: 5px 10px 5px 12px;
        font-size: 13px;
        font-weight: 500;
        animation: fadeIn 0.18s ease;
    }

    .chip-remove {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: none;
        border: none;
        cursor: pointer;
        color: #01696f;
        font-size: 11px;
        padding: 0;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        opacity: 0.7;
        transition: opacity 0.15s, background 0.15s;
    }

    .chip-remove:hover {
        opacity: 1;
        background-color: rgba(1, 105, 111, 0.15);
    }

    .sticky-submit {
        position: sticky;
        bottom: 12px;
        z-index: 20;
        padding-top: 8px;
        background: linear-gradient(to top, rgba(248, 249, 250, 1), rgba(248, 249, 250, 0.82), rgba(248, 249, 250, 0));
        backdrop-filter: blur(6px);
    }

    .submit-btn {
        min-height: 52px;
        border-radius: 14px;
        font-weight: 600;
        letter-spacing: 0.01em;
        box-shadow: 0 10px 24px rgba(1, 105, 111, 0.18);
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        font-size: 14px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        transition: background 0.2s ease;
    }

    .submit-btn:disabled {
        opacity: 0.85;
    }

    .btn-spinner {
        width: 16px;
        height: 16px;
        border: 2px solid rgba(255, 255, 255, 0.45);
        border-top-color: #fff;
        border-radius: 50%;
        animation: spin .7s linear infinite;
        flex-shrink: 0;
    }

    .fade-in {
        animation: fadeIn 0.22s ease;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(-6px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }

    .radio-pill-group {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
    }

    .radio-pill {
        position: relative;
    }

    .radio-pill input {
        position: absolute;
        opacity: 0;
        pointer-events: none;
    }

    .radio-pill span {
        display: inline-block;
        padding: 8px 16px;
        border-radius: 999px;
        border: 1px solid #d1d5db;
        background: #fff;
        font-size: 13px;
        font-weight: 500;
        color: #374151;
        cursor: pointer;
        transition: all 0.15s ease;
    }

    .radio-pill input:checked + span {
        background: #0b7285;
        border-color: #0b7285;
        color: #fff;
    }

    .radio-pill input:focus-visible + span {
        box-shadow: 0 0 0 3px rgba(11, 114, 133, 0.25);
    }


    .file-list {
        display: flex;
        flex-direction: column;
        gap: 6px;
        margin-top: 10px;
    }

    .file-attached {
        display: flex;
        align-items: center;
        gap: 8px;
        background: #f7f8f8;
        border: 1px solid #e3e7ea;
        border-radius: 12px;
        padding: 10px 14px;
        font-size: 14px;
    }

    .file-attached ion-icon {
        font-size: 18px;
        color: #0b7285;
        flex-shrink: 0;
    }

    .file-name {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #28251d;
    }

    .file-drop {
        display: flex;
        align-items: center;
        gap: 8px;
        border: 1.5px dashed #d1d5db;
        border-radius: 12px;
        padding: 14px;
        cursor: pointer;
        color: #0b7285;
        font-size: 14px;
        font-weight: 500;
        transition: border-color .15s, background .15s;
    }

    .file-drop:hover {
        background: #f0f7f8;
        border-color: #0b7285;
    }

    .file-spinner {
        width: 14px;
        height: 14px;
        border-width: 2px;
        border-color: rgba(11, 114, 133, 0.3);
        border-top-color: #0b7285;
        margin-left: auto;
    }
</style>